<p-dialog [(visible)]="visible" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
    <div class="d-flex flex-column justify-content-center">
        <div class="text-center">
            <img src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-logo.png" width="50%" height="auto"
                alt="FocusPay Payments Logo">
        </div>
        
        <div class="h3 text-center">
            Thanks!
        </div>
        <div class="h4 text-center">
            Your application has been submitted successfully.
        </div>
        <div class="text-center mb-2">
            Our Payment Services team will review your application and email you with any questions they might have.
        </div>
        <div class="text-center mb-2">
            You'll be receiving an email shortly to confirm your application. That email will contain a link for your to view the status of your application.
            Once your application has been reviewed and approved, you'll be able to create a login to access your FocusPay services.
        </div>
        <div class="text-center fc-font-size-small">Application ID: {{applicationId}}</div>
    </div>
</p-dialog>